import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import {UserMsgCount} from '../../../../../redux/Slice/chatSlice'
import {useCallback, useEffect} from 'react'

export function AdminMenu() {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const dispatch = useAppDispatch()
  const {msgCount} = useAppSelector((state) => state.chat)

  const fetchMessageCount = useCallback(() => {
    dispatch(UserMsgCount())
  }, [dispatch])

  useEffect(() => {
    fetchMessageCount()
  }, [fetchMessageCount])

  return (
    <>
      {/*  student menu */}
      {(hasPermission('student-applications-list') ||
        hasPermission('student-application-archive-list') ||
        hasPermission('student-archive-list') ||
        hasPermission('students-list')) && (
        <MenuInnerWithSub
          title={t('MENU.STUDENTS')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('student-applications-list') && (
            <MenuItem
              to='/student/student-applications-list'
              fontIcon='fa fa-user-pen text-white mx-2'
              title={t('MENU.APPLICATIONS')}
            />
          )}
          {hasPermission('student-application-archive-list') && (
            <MenuItem
              to='/student/archived-applications-list'
              fontIcon='fa fa-archive text-white mx-2'
              title={t('MENU.ARCHIVED_APPLICATIONS')}
            />
          )}
          {hasPermission('student-applications-list') && (
            <MenuItem
              to='/student/online-applications'
              fontIcon='fa fa-globe text-white mx-2'
              title={t('MENU.ONLINE_APPLICATIONS')}
            />
          )}
          {hasPermission('students-list') && (
            <MenuItem
              to='/student/students-list'
              fontIcon='fa fa-users-viewfinder text-white mx-2'
              title={t('MENU.STUDENTS')}
            />
          )}
          {hasPermission('student-archive-list') && (
            <MenuItem
              to='/student/archived-students-list'
              fontIcon='fa fa-archive text-white mx-2'
              title={t('MENU.ARCHIVED_STUDENTS')}
            />
          )}
          {hasPermission('student-alumni') && (
            <MenuItem
              to='/student/alumni-students-list'
              fontIcon='fa fa-user-graduate text-white mx-2'
              title={t('MENU.ALUMNI')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/*  lecturer menu */}
      {(hasPermission('lecturers-list') ||
        hasPermission('archived-lecturers-list') ||
        hasPermission('lecturer-contracts-list')) && (
        <MenuInnerWithSub
          title={t('MENU.LECTURERS')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('lecturers-list') && (
            <MenuItem
              to='/admin/lecturers-list'
              fontIcon='fa fa-users text-white mx-2'
              title={t('MENU.LECTURERS')}
            />
          )}
          {hasPermission('lecturer-contracts-list') && (
            <MenuItem
              to='/admin/lecturer-contracts'
              fontIcon='fa fa-file-signature text-white mx-2'
              title={t('MENU.CONTRACTS')}
            />
          )}

          {hasPermission('archived-lecturers-list') && (
            <MenuItem
              to='/admin/archived-lecturers-list'
              fontIcon='fa fa-user-lock text-white mx-2'
              title={t('MENU.ARCHIVED_LECTURERS')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* academic menu */}
      {(hasPermission('campus-faculties-list') ||
        hasPermission('publication-categories-list') ||
        hasPermission('publications-list') ||
        hasPermission('video-libraries-list') ||
        hasPermission('programs-list') ||
        hasPermission('timetable-list') ||
        hasPermission('courses-list')) && (
        <MenuInnerWithSub
          title={t('MENU.ACADEMICS')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('campus-faculties-list') && (
            <MenuItem
              to='/academics/campus-faculties-list'
              fontIcon='fa fa-list-alt text-white mx-2'
              title={t('MENU.FACULTIES')}
            />
          )}
          {hasPermission('timetable-list') && (
            <MenuItem
              to='/academics/timetable-list'
              fontIcon='fa fa-list-alt text-white mx-2'
              title={t('MENU.TIME_TABLES')}
            />
          )}

          {hasPermission('programs-list') && (
            <MenuItem
              to='/tools/programs-list'
              fontIcon='fa fa-list-alt text-white mx-2'
              title={t('MENU.PROGRAMS')}
            />
          )}
          {hasPermission('courses-list') && (
            <MenuItem
              to='/academics/courses-list'
              fontIcon='fa fa-list-alt text-white mx-2'
              title={t('MENU.COURSES')}
            />
          )}
          {hasPermission('publication-categories-list') && (
            <MenuItem
              to='/academics/publication-categories-list'
              fontIcon='fa fa-list-alt text-white mx-2'
              title={t('MENU.PUBLICATION_CATEGORIES')}
            />
          )}
          {hasPermission('publication-fields-list') && (
            <MenuItem
              to='/academics/publication-fields-list'
              fontIcon='fa fa-list-alt text-white mx-2'
              title={t('MENU.PUBLICATION_FIELDS')}
            />
          )}
          {hasPermission('publications-list') && (
            <MenuItem
              to='/academics/publications-list'
              fontIcon='fa fa-book-open text-white mx-2'
              title={t('MENU.PUBLICATIONS')}
            />
          )}
          {hasPermission('video-libraries-list') && (
            <MenuItem
              to='/academics/video-libraries-list'
              fontIcon='fa fa-video text-white mx-2'
              title={t('MENU.VIDEO_LIBRARIES')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* finance menu */}
      {hasPermission('student-invoices-list') && (
        <MenuInnerWithSub
          title={t('MENU.FINANCE')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('student-invoices-list') && (
            <MenuItem
              to='/finance/student-invoices-list'
              fontIcon='fa fa-table-list text-white mx-2'
              title={t('MENU.STUDENT_INVOICES')}
            />
          )}
          {hasPermission('student-invoices-list') && (
            <MenuItem
              to='/finance/organization-invoices-list'
              fontIcon='fa fa-table-list text-white mx-2'
              title={t('MENU.ORGANIZATION_INVOICES')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* report menu */}
      {(hasPermission('student-annual-report') ||
        hasPermission('alumni-annual-report') ||
        hasPermission('lecturer-annual-report')) && (
        <MenuInnerWithSub
          title={t('MENU.REPORT')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          <MenuItem
            to='/admin/course-ev-report'
            fontIcon='fa fa-chart-simple text-white mx-2'
            title={t('LABEL.COURSE_SUVERY_FORM')}
          />
          {hasPermission('student-annual-report') && (
            <MenuItem
              to='/admin/std-ann-survery'
              fontIcon='fa fa-chart-simple text-white mx-2'
              title={t('LABEL.STD_ANN_REPORT')}
            />
          )}
          {hasPermission('alumni-annual-report') && (
            <MenuItem
              to='/admin/alm-ann-survery'
              fontIcon='fa fa-chart-simple text-white mx-2'
              title={t('LABEL.ALUM_ANN_REPORT')}
            />
          )}
          {hasPermission('lecturer-annual-report') && (
            <MenuItem
              to='/admin/lec-ann-survery'
              fontIcon='fa fa-chart-simple text-white mx-2'
              title={t('LABEL.LEC_ANN_REPORT')}
            />
          )}
          <MenuItem
            to='/admin/finance-rep'
            fontIcon='fa fa-usd text-white mx-2'
            title={t('MENU.STUDENT_PAYMENT_REPORT')}
          />
          <MenuItem
            to='/admin/org-rep'
            fontIcon='fa fa-usd text-white mx-2'
            title={t('MENU.ORG_PAYMENT_REPORT')}
          />
        </MenuInnerWithSub>
      )}

      {/* COMMUNICATION */}
      {(hasPermission('news-list') ||
        hasPermission('news-archive-list') ||
        hasPermission('email-services')) && (
        <MenuInnerWithSub
          title={t('MENU.COMMUNICATION')}
          to=''
          menuPlacement='bottom-end'
          menuTrigger='click'
          hasArrow={true}
          fontIcon=''
        >
          {hasPermission('email-services') && (
            <MenuItem
              to='/admin/email-services'
              fontIcon='fa fa-envelope text-white mx-2'
              title={t('MENU.EMAIL_SERVICES')}
            />
          )}
          {hasPermission('news-list') && (
            <MenuItem
              to='/admin/news-list'
              fontIcon='fa fa-newspaper text-white mx-2'
              title={t('MENU.NEWS_AND_ANNOUNCEMENTS')}
            />
          )}
          {hasPermission('news-archive-list') && (
            <MenuItem
              to='/admin/archived-news-list'
              fontIcon='fa fa-archive text-white mx-2'
              title={t('LABEL.ARCHIVED_NEWS_AND_ANNOUNCEMENTS')}
            />
          )}
        </MenuInnerWithSub>
      )}

      {/* ADMINISTRATION MENU */}
      {(hasPermission('campuses-list') ||
        hasPermission('campus-banks-list') ||
        hasPermission('campus-managers-list') ||
        hasPermission('campus-gradings-list') ||
        hasPermission('users-list') ||
        hasPermission('roles-list') ||
        hasPermission('sections-list') ||
        hasPermission('academic-years-list') ||
        hasPermission('program-years-list') ||
        hasPermission('program-levels-list') ||
        hasPermission('semesters-list') ||
        hasPermission('countries-list') ||
        hasPermission('organizations-list') ||
        hasPermission('currencies-list') ||
        hasPermission('video-categories-list') ||
        hasPermission('regulation-categories-list') ||
        hasPermission('regulations-list')) && (
        <MenuInnerWithSub
          title={t('MENU.ADMINISTRATION')}
          to=''
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={true}
        >
          {/* campus */}
          {(hasPermission('campuses-list') ||
            hasPermission('campus-banks-list') ||
            hasPermission('campus-managers-list') ||
            hasPermission('campus-gradings-list')) && (
            <MenuInnerWithSub
              title={t('MENU.CAMPUSES')}
              to=''
              fontIcon='fa fa-building'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('campuses-list') && (
                <MenuItem
                  to='/campuses/campuses-list'
                  fontIcon='fa fa-building text-white mx-2'
                  title={t('MENU.CAMPUSES')}
                />
              )}

              {hasPermission('campus-banks-list') && (
                <MenuItem
                  to='/campuses/campus-banks-list'
                  fontIcon='fa fa-building-columns text-white mx-2'
                  title={t('MENU.CAMPUS_BANKS')}
                />
              )}

              {hasPermission('campus-managers-list') && (
                <MenuItem
                  to='/campuses/campus-managers-list'
                  fontIcon='fa fa-users text-white mx-2'
                  title={t('MENU.CAMPUS_MANAGERS')}
                />
              )}
              {hasPermission('campus-gradings-list') && (
                <MenuItem
                  to='/campuses/campus-gradings-list'
                  fontIcon='fa fa-vote-yea text-white mx-2'
                  title={t('MENU.CAMPUS_GRADINGS')}
                />
              )}
            </MenuInnerWithSub>
          )}
          {/* users */}
          {(hasPermission('users-list') || hasPermission('roles-list')) && (
            <MenuInnerWithSub
              title={t('MENU.USERS')}
              to=''
              fontIcon='fa fa-users'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('users-list') && (
                <MenuItem
                  to='/users-list'
                  fontIcon='fa fa-users text-white mx-2'
                  title={t('MENU.STAFF_USERS')}
                />
              )}
              {hasPermission('users-list') && (
                <MenuItem
                  to='/lecturer-users'
                  fontIcon='fa fa-users text-white mx-2'
                  title={t('MENU.LECTURER_USERS')}
                />
              )}
              {hasPermission('users-list') && (
                <MenuItem
                  to='/student-users'
                  fontIcon='fa fa-users text-white mx-2'
                  title={t('MENU.STUDENT_USERS')}
                />
              )}
              {hasPermission('roles-list') && (
                <MenuItem
                  to='/roles-list'
                  fontIcon='fa fa-lock-open text-white'
                  title={t('MENU.ROLES')}
                />
              )}
            </MenuInnerWithSub>
          )}
          {/* tools */}
          {(hasPermission('sections-list') ||
            hasPermission('academic-years-list') ||
            hasPermission('program-years-list') ||
            hasPermission('program-levels-list') ||
            hasPermission('semesters-list') ||
            hasPermission('organizations-list') ||
            hasPermission('countries-list') ||
            hasPermission('currencies-list') ||
            hasPermission('video-categories-list')) && (
            <MenuInnerWithSub
              title={t('MENU.TOOLS')}
              to=''
              fontIcon='fa fa-tools'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('organizations-list') && (
                <MenuItem
                  to='/finance/organizations-list'
                  fontIcon='fa fa-building-columns text-white mx-2'
                  title={t('MENU.ORGANIZATIONS')}
                />
              )}
              {hasPermission('sections-list') && (
                <MenuItem
                  to='/tools/sections-list'
                  fontIcon='fa fa-layer-group text-white mx-2'
                  title={t('MENU.SECTIONS')}
                />
              )}
              {hasPermission('academic-years-list') && (
                <MenuItem
                  to='/tools/academic-years-list'
                  fontIcon='fa fa-hourglass-half text-white'
                  title={t('MENU.ACADEMIC_YEARS')}
                />
              )}
              {hasPermission('program-years-list') && (
                <MenuItem
                  to='/tools/program-years-list'
                  fontIcon='fa fa-list text-white'
                  title={t('MENU.PROGRAM_YEARS')}
                />
              )}
              {hasPermission('program-levels-list') && (
                <MenuItem
                  to='/tools/program-levels-list'
                  fontIcon='fa fa-user-graduate text-white'
                  title={t('MENU.PROGRAM_LEVELS')}
                />
              )}
              {hasPermission('semesters-list') && (
                <MenuItem
                  to='/tools/semesters-list'
                  fontIcon='fa fa-columns text-white'
                  title={t('MENU.SEMESTERS')}
                />
              )}
              {hasPermission('countries-list') && (
                <MenuItem
                  to='/tools/countries-list'
                  fontIcon='fa fa-globe text-white'
                  title={t('MENU.COUNTRIES')}
                />
              )}
              {hasPermission('currencies-list') && (
                <MenuItem
                  to='/tools/currencies-list'
                  fontIcon='fa fa-coins text-white mx-2'
                  title={t('MENU.CURRENCIES')}
                />
              )}
              {hasPermission('video-categories-list') && (
                <MenuItem
                  to='/tools/video-categories-list'
                  fontIcon='fa fa-film text-white'
                  title={t('MENU.VIDEO_CATEGORIES')}
                />
              )}

              {/* {hasPermission('application-letters-list') && (
                <MenuItem
                  to='/tools/application-letters-list'
                  fontIcon='fa fa-envelope text-white'
                  title={t('MENU.APPLICATION_LETTERS')}
                />
              )} */}
              {hasPermission('form-list') && (
                <MenuItem
                  to='/admin/forms'
                  fontIcon='fa fa-poll text-white mx-2'
                  title={t('MENU.FORMS')}
                />
              )}
            </MenuInnerWithSub>
          )}
          {/* regulations */}
          {(hasPermission('regulation-categories-list') || hasPermission('regulations-list')) && (
            <MenuInnerWithSub
              title={t('MENU.REGULATIONS')}
              to=''
              fontIcon='fa fa-scale-balanced'
              hasArrow={true}
              menuPlacement='right-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {hasPermission('regulation-categories-list') && (
                <MenuItem
                  to='/admin/regulation-categories-list'
                  fontIcon='fa fa-sliders text-white mx-2'
                  title={t('MENU.REGULATION_CATEGORIES')}
                />
              )}

              {hasPermission('regulations-list') && (
                <MenuItem
                  to='/admin/regulations-list'
                  fontIcon='fa fa-scale-balanced text-white mx-2'
                  title={t('MENU.REGULATIONS')}
                />
              )}
            </MenuInnerWithSub>
          )}
        </MenuInnerWithSub>
      )}
      {/* END OF ADMINISTRATION MENU */}

      <MenuItem
        to='/chat/ad-chat-room'
        title={
          <span className='position-relative'>
            {t('LABEL.CHAT')}
            <span className='badge badge-circle bg-danger position-absolute top-0 text-white translate-middle'>
              {msgCount}
            </span>
          </span>
        }
      />
    </>
  )
}
